module.exports = __webpack_public_path__ + "img/indu_16.b467d4f7.png";